import { SVGProps } from "react";

const GILogicGateAnd = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em" height="1em" {...props}><path d="M0 0h512v512H0z" /><path fill="#fff" d="M105 105v302h151c148 0 148-302 0-302H105zm-89 46v18h71v-18H16zm368.8 96c.2 6 .2 12 0 18H496v-18H384.8zM16 343v18h71v-18H16z" /></svg>;

export { GILogicGateAnd };